/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from '@app/app.config';
import { AppComponent } from '@app/app.component';
import './extensions/string.extensions';
import * as Sentry from '@sentry/angular';
import { environment } from '@env/environment';
import { browserTracingIntegration } from '@core/integrations/browser-tracing.integration';

Sentry.init({
    ...environment.sentry,
    enabled: environment.sentry.enabled || false,
    integrations: [
        browserTracingIntegration(),
        Sentry.replayIntegration({
            networkDetailAllowUrls: [environment.apiUrl],
        }),
        Sentry.httpContextIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
